import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Kothrudtomumbaicabs() {



  const cardData = {


  keyword: "Kothrud to Mumbai Cabs",

  headingDescription: "Trustline Cab provides reliable Kothrud to Mumbai cab services with comfortable vehicles, professional chauffeurs, and affordable travel solutions for corporate trips, airport transfers, family journeys, and outstation travel. Whether you require a one-way taxi or a round-trip cab, we ensure safe, punctual, and hassle-free transportation with well-maintained cars. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles suitable for every travel requirement. With transparent pricing, doorstep pickup, easy online booking, and 24/7 customer assistance, Trustline Travels is your trusted choice for Kothrud to Mumbai taxi services.",

  topPlaces: [
    {
      title: "Turbhe Industrial Area",
      description: "Turbhe Industrial Area in Navi Mumbai is a major commercial and industrial zone with manufacturing units, logistics companies, warehouses, and business establishments."
    },
    {
      title: "Millennium Business Park",
      description: "Millennium Business Park in Mahape is a leading IT and corporate destination featuring technology companies, software firms, and modern office spaces."
    },
    {
      title: "Belapur CBD",
      description: "Belapur CBD is an important commercial district of Navi Mumbai with government offices, corporate headquarters, financial institutions, and business centers."
    },
    {
      title: "MIDC Andheri",
      description: "MIDC Andheri is a well-known industrial and commercial area housing IT companies, manufacturing units, and corporate offices."
    },
    {
      title: "Peninsula Corporate Park",
      description: "Peninsula Corporate Park in Lower Parel is a premium business complex with multinational companies, financial firms, and corporate offices."
    },
    {
      title: "Ghansoli Business Hub",
      description: "Ghansoli is a growing business destination in Navi Mumbai known for corporate campuses, technology companies, and modern commercial developments."
    },
    {
      title: "Elephanta Caves",
      description: "Elephanta Caves is a UNESCO World Heritage Site famous for ancient rock-cut temples, historic sculptures, and cultural significance."
    },
    {
      title: "Powai Lake",
      description: "Powai Lake is a scenic urban attraction surrounded by greenery, modern developments, and peaceful views, making it a popular leisure destination."
    },
    {
      title: "Hanging Gardens",
      description: "Hanging Gardens is a beautiful hilltop garden offering panoramic views of Mumbai city and the Arabian Sea."
    },
    {
      title: "Colaba Causeway",
      description: "Colaba Causeway is a vibrant shopping destination known for street markets, cafés, handicrafts, and the cultural charm of South Mumbai."
    }
  ],





"services": [
  {
    "name": "Kothrud to Mumbai Cab",
    "description": "Book Kothrud to Mumbai cab service for comfortable and reliable intercity travel with Sedan, Ertiga, Innova Crysta, SUV, and premium car options. Get doorstep pickup, professional chauffeurs, transparent pricing, and safe transportation for airport transfers, corporate travel, family trips, sightseeing, and outstation journeys."
  },
  {
    "name": "Kothrud to Mumbai Airport Cab",
    "description": "Reserve Kothrud to Mumbai Airport cab for smooth airport transfers with timely pickup, luggage assistance, flight tracking support, and experienced drivers. Ideal for domestic and international airport travel with comfortable AC vehicles."
  },
  {
    "name": "Kothrud to Mumbai International Airport Cab",
    "description": "Book Kothrud to Mumbai International Airport cab for direct transfer to Chhatrapati Shivaji Maharaj International Airport with reliable service, premium vehicles, and professional chauffeurs."
  },
  {
    "name": "Kothrud to Mumbai One Way Cab",
    "description": "Choose Kothrud to Mumbai one way cab for affordable single-side travel. Suitable for airport drops, business meetings, relocation, and personal journeys with fixed pricing and comfortable vehicles."
  },
  {
    "name": "Kothrud to Mumbai Drop Taxi",
    "description": "Get Kothrud to Mumbai drop taxi service with direct routes, punctual pickup, clean AC cars, professional drivers, and affordable one-way travel solutions."
  },
  {
    "name": "Kothrud to Dadar Taxi Service",
    "description": "Book Kothrud to Dadar taxi service for railway station transfers, business visits, and city travel with experienced chauffeurs and comfortable Sedan, Ertiga, and Innova vehicles."
  },
  {
    "name": "Kothrud to Bandra Taxi Service",
    "description": "Reliable Kothrud to Bandra taxi service for corporate travel, meetings, airport transfers, and personal trips with premium AC vehicles and professional drivers."
  },
  {
    "name": "Kothrud to Mumbai Darshan Cab",
    "description": "Book Kothrud to Mumbai Darshan cab for sightseeing tours covering popular Mumbai attractions with flexible travel plans, comfortable vehicles, and experienced local drivers."
  },
  {
    "name": "Pune to Mumbai Taxi",
    "description": "Reliable Pune to Mumbai taxi service for airport transfers, business travel, family trips, and outstation journeys with multiple vehicle options and affordable pricing."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport cab with direct pickup from Kothrud and other Pune locations. Enjoy punctual airport transfers, luggage support, and comfortable chauffeur-driven cars."
  },
  {
    "name": "Pune to Mumbai Ertiga Cab",
    "description": "Choose Pune to Mumbai Ertiga cab for spacious and comfortable family travel, airport transfers, and group journeys with affordable fares and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Innova Cab",
    "description": "Premium Pune to Mumbai Innova cab service offers luxury seating, extra luggage space, and smooth highway travel for families, corporates, and long-distance passengers."
  },
  {
    "name": "Kothrud to Mumbai Cab Service",
    "description": "Professional Kothrud to Mumbai cab service offering one-way, round-trip, airport, corporate, and outstation travel with clean vehicles and trained chauffeurs."
  },
  {
    "name": "Kothrud to Mumbai Innova Cab Service",
    "description": "Book Kothrud to Mumbai Innova cab service for premium comfort, spacious seating, family travel, airport transfers, and corporate transportation."
  },
  {
    "name": "Kothrud to Dadar Cab Service",
    "description": "Reliable Kothrud to Dadar cab service with doorstep pickup, comfortable AC vehicles, professional drivers, and affordable pricing."
  },
  {
    "name": "Kothrud to Andheri Cab Service",
    "description": "Reserve Kothrud to Andheri cab service for business travel, airport connections, meetings, and personal transportation with flexible booking options."
  },
  {
    "name": "Innova Crysta on Rent in Kothrud Pune",
    "description": "Hire Innova Crysta on rent in Kothrud Pune for airport transfers, Mumbai travel, family vacations, corporate trips, and premium outstation journeys with chauffeur service."
  },
  {
    "name": "Toyota Innova Crysta Car Hire in Pune",
    "description": "Toyota Innova Crysta car hire in Pune provides luxury travel solutions with spacious interiors, comfortable seating, professional drivers, and flexible rental plans."
  },
  {
    "name": "Pune Mumbai Velocity Cabs",
    "description": "Pune Mumbai Velocity Cabs offers reliable taxi services including one-way cab, airport transfer, corporate travel, and round-trip transportation with premium vehicles."
  },
  {
    "name": "Cab Service in Pune",
    "description": "Our cab service in Pune provides local rides, airport transfers, corporate transportation, and outstation taxi services with Sedan, Ertiga, Innova Crysta, and SUV options."
  },
  {
    "name": "Pune Mumbai Cab",
    "description": "Book Pune Mumbai cab for safe and comfortable travel between Pune and Mumbai with professional chauffeurs and affordable travel packages."
  },
  {
    "name": "Cab Service in Kothrud",
    "description": "Trusted cab service in Kothrud for local transportation, airport transfers, corporate travel, and long-distance journeys with well-maintained vehicles."
  },
  {
    "name": "Cab Service in Kothrud Contact Number",
    "description": "Contact Kothrud cab service for quick bookings, airport transfers, outstation trips, and reliable taxi solutions with professional customer support."
  },
  {
    "name": "Kothrud to Outstation Cabs Service",
    "description": "Book Kothrud to outstation cabs service for long-distance travel with comfortable vehicles, experienced drivers, flexible schedules, and transparent pricing."
  },
  {
    "name": "Kothrud to Mumbai Cabs",
    "description": "Affordable Kothrud to Mumbai cabs available for airport transfers, business trips, family travel, and one-way journeys with multiple vehicle categories."
  },
  {
    "name": "Kothrud to Mumbai Taxi",
    "description": "Choose Kothrud to Mumbai taxi for safe, comfortable, and reliable transportation with professional chauffeurs and clean AC vehicles."
  },
  {
    "name": "Kothrud to Mumbai Taxi Service",
    "description": "Book Kothrud to Mumbai taxi service for dependable travel with Sedan, Ertiga, Innova Crysta, SUV, and luxury car options."
  },
  {
    "name": "Kothrud to Mumbai Taxi Booking",
    "description": "Book Kothrud to Mumbai taxi online with instant confirmation, easy reservation process, flexible pickup timing, and 24x7 support."
  },
  {
    "name": "Cab from Kothrud to Mumbai",
    "description": "Reserve a cab from Kothrud to Mumbai for airport travel, business meetings, sightseeing, and family journeys with experienced drivers."
  },
  {
    "name": "Kothrud to Mumbai Car Rental",
    "description": "Kothrud to Mumbai car rental service offers one-way, round-trip, airport, and corporate travel options with premium chauffeur-driven vehicles."
  },
  {
    "name": "Kothrud to Mumbai One Way Cab",
    "description": "Book Kothrud to Mumbai one way cab for economical single-trip travel without return charges. Perfect for airport drops and personal journeys."
  },
  {
    "name": "Cheap Kothrud to Mumbai Cabs",
    "description": "Affordable Kothrud to Mumbai cabs with transparent fares, comfortable AC cars, experienced drivers, and reliable service for every travel requirement."
  },
  {
    "name": "Kothrud to Mumbai Taxi Fare",
    "description": "Check Kothrud to Mumbai taxi fare with competitive pricing for Sedan, Ertiga, Innova Crysta, and SUV vehicles with no hidden charges."
  },
  {
    "name": "Book Kothrud to Mumbai Cab Online",
    "description": "Book Kothrud to Mumbai cab online with instant booking confirmation, multiple vehicle choices, secure payment options, and professional chauffeur service."
  },
  {
    "name": "Kothrud to Mumbai Outstation Cab",
    "description": "Reliable Kothrud to Mumbai outstation cab for long-distance travel with experienced drivers, comfortable vehicles, and flexible pickup schedules."
  },
  {
    "name": "24x7 Kothrud to Mumbai Taxi Service",
    "description": "24x7 Kothrud to Mumbai taxi service available for airport transfers, emergency travel, business trips, and family journeys anytime."
  },
  {
    "name": "Best Kothrud to Mumbai Cab Service",
    "description": "Experience the best Kothrud to Mumbai cab service with premium vehicles, professional chauffeurs, transparent pricing, easy booking, and reliable customer support."
  }
],

"tableData": [
  ["Kothrud to Mumbai Cab", "Kothrud to Mumbai Airport Cab"],
  ["Kothrud to Mumbai International Airport Cab", "Kothrud to Mumbai One Way Cab"],
  ["Kothrud to Mumbai Drop Taxi", "Kothrud to Dadar Taxi Service"],
  ["Kothrud to Bandra Taxi Service", "Kothrud to Mumbai Darshan Cab"],
  ["Pune to Mumbai Taxi", "Pune to Mumbai Airport Cab"],
  ["Pune to Mumbai Ertiga Cab", "Pune to Mumbai Innova Cab"],
  ["Kothrud to Mumbai Cab Service", "Kothrud to Mumbai Innova Cab Service"],
  ["Kothrud to Dadar Cab Service", "Kothrud to Andheri Cab Service"],
  ["Innova Crysta on Rent in Kothrud Pune", "Toyota Innova Crysta Car Hire in Pune"],
  ["Pune Mumbai Velocity Cabs", "Cab Service in Pune"],
  ["Pune Mumbai Cab", "Cab Service in Kothrud"],
  ["Kothrud to Outstation Cabs Service", "Kothrud to Mumbai Cabs"],
  ["Kothrud to Mumbai Taxi", "Kothrud to Mumbai Taxi Service"],
  ["Kothrud to Mumbai Taxi Booking", "Cab from Kothrud to Mumbai"],
  ["Kothrud to Mumbai Car Rental", "Kothrud to Mumbai One Way Cab"],
  ["Cheap Kothrud to Mumbai Cabs", "Kothrud to Mumbai Taxi Fare"],
  ["Book Kothrud to Mumbai Cab Online", "Kothrud to Mumbai Outstation Cab"],
  ["24x7 Kothrud to Mumbai Taxi Service", "Best Kothrud to Mumbai Cab Service"]
],






whychoose: [
  {
    WhyChooseheading: "Trusted Kothrud to Mumbai Cab Service",
    WhyChoosedescription: "Trustline Cab provides reliable Kothrud to Mumbai cab services with comfortable rides for business trips, airport transfers, and personal travel."
  },
  {
    WhyChooseheading: "Easy Pickup from Kothrud Area",
    WhyChoosedescription: "We offer doorstep pickup from Kothrud, Karve Nagar, Bavdhan, Warje, Paud Road, and nearby Pune locations."
  },
  {
    WhyChooseheading: "Experienced Drivers for Expressway Travel",
    WhyChoosedescription: "Our professional drivers have excellent route knowledge and ensure a safe and smooth journey between Pune and Mumbai."
  },
  {
    WhyChooseheading: "Affordable Cab Packages",
    WhyChoosedescription: "Get competitive pricing with transparent fare details and no hidden charges for your Kothrud to Mumbai trip."
  },
  {
    WhyChooseheading: "Clean & Comfortable Vehicles",
    WhyChoosedescription: "Travel in well-maintained Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for a relaxed journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Return Trips",
    WhyChoosedescription: "Choose one-way cabs, round trips, or customized travel options based on your convenience."
  },
  {
    WhyChooseheading: "Airport & Corporate Travel Support",
    WhyChoosedescription: "Our cab services are suitable for Mumbai Airport transfers, office meetings, business travel, and family visits."
  },
  {
    WhyChooseheading: "Quick Booking Assistance",
    WhyChoosedescription: "Our support team provides instant quotations and smooth booking assistance whenever you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Kothrud to Mumbai cab service?",
    answer: "Yes, Trustline Cab offers dependable Kothrud to Mumbai cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Kothrud to Mumbai?",
    answer: "Yes, we provide affordable one-way cab services with convenient pickup options from Kothrud and nearby areas."
  },
  {
    question: "Which vehicles are available for Kothrud to Mumbai travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for different travel requirements."
  },
  {
    question: "Do you provide pickup from nearby Kothrud locations?",
    answer: "Yes, pickup is available from Kothrud, Karve Nagar, Bavdhan, Warje, Paud Road, and surrounding areas."
  },
  {
    question: "Can I book a cab from Kothrud to Mumbai Airport?",
    answer: "Yes, we offer direct airport cab services from Kothrud to Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in your booking quotation."
  },
  {
    question: "Is Kothrud to Mumbai cab service available 24 hours?",
    answer: "Yes, Trustline Cab provides round-the-clock cab services for early morning, daytime, and night travel."
  },
  {
    question: "Can I book my cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup."
  },
  {
    question: "Do you provide cabs for corporate travel from Kothrud?",
    answer: "Yes, our cab services support corporate professionals traveling between Pune and Mumbai for meetings and official work."
  },
  {
    question: "How can I book a Kothrud to Mumbai cab with Trustline Travels?",
    answer: "Simply provide your pickup location, travel date, destination, and preferred vehicle details to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ajay Deshmukh",
    feedback: "Trustline Travels provided a smooth and comfortable ride from Kothrud to Mumbai. The driver was punctual, the vehicle was clean, and the complete journey was managed professionally.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Kulkarni",
    feedback: "We booked a family cab from Kothrud to Mumbai, and the experience was excellent. The spacious vehicle and courteous driver made our travel easy and enjoyable.",
    rating: 5
  }
];











  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kothrud to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/kothrud-to-mumbai-cab.webp",
  "description": "Book Kothrud to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way, round-trip, and airport taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5286"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/kothrud-to-mumbai-cab"
  }
};


  return (
    <div>
<Helmet>
  <title>Kothrud to Mumbai Cab | One Way & Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Kothrud to Mumbai cab service with Trustline Travels for affordable one-way, round-trip, and airport transfers. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with experienced drivers and 24x7 service."
  />

  <meta
    name="keywords"
    content="kothrud to mumbai airport cab, kothrud to mumbai international airport cab, kothrud to mumbai one way cab, kothrud to mumbai drop taxi, kothrud to dadar taxi service, kothrud to mumbai cab, kothrud to mumbai taxi service, kothrud to mumbai airport taxi, kothrud to mumbai innova cab, kothrud to mumbai ertiga cab, kothrud mumbai one way taxi, kothrud to mumbai round trip cab, pune to mumbai cab from kothrud"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/44.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Kothrudtomumbaicabs;